import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Produkt-Statistik Umzüge — Betreiber-Sicht, nur lesend. Gesamtzahl der
 * Umzugs-Jobs und Tenants plus Aufschlüsselung nach Status und Kind.
 * M2M-Auth wie alle /v1/admin/*-Endpoints.
 */
const FIXTURE = {
  jobs: 486,
  tenants: 213,
  byStatus: [
    { status: 'done', n: 402 },
    { status: 'running', n: 21 },
    { status: 'failed', n: 34 },
    { status: 'queued', n: 29 },
  ],
  byKind: [
    { kind: 'wordpress', n: 208 },
    { kind: 'mailbox', n: 141 },
    { kind: 'dns', n: 87 },
    { kind: 'database', n: 50 },
  ],
};

export function useMigrationStats() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['product-stats-migration', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/product-stats/migration');
    },
    refetchInterval: 60_000,
  });
}
